<template>
  <component
    :is="componentName"
    :url="url"
    :fileName="fileName"
    :extendName="extendName"
    :canRemove="canRemove"
    :canDownload="canDownload"
    :canPreview="canPreview"
    @remove="remove"
    @download="download"
    @preview="preview"
    >
      <template slot="previewFileItem" slot-scope="{url, fileName, extendName}" v-if="$scopedSlots.previewFileItem">
        <slot
          name="previewFileItem"
          :url="url"
          :fileName="fileName"
          :extendName="extendName"
        >
        </slot>
      </template>
  </component>
</template>
<script>
import FileItem from './file-item.vue'
import FileImage from './file-image.vue'
import { openPreview } from '../preview'
export default {
  name: 'KyePreview',
  components: {
    FileItem,
    FileImage,
  },
  props: {
    viewType: {
      type: String,
      default: 'list' // list, image
    },
    url: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    extendName: {
      type: String,
      default: ''
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    beforeRemove: {
      type: Function,
    },
    beforePreview: {
      type: Function,
    },
    beforeDownload: {
      type: Function,
    },
    imageProps: {
      type: Object,
      default: () => ({})
    },
    dialogOption: {
      type: Object,
      default: () => ({
        title: '图片查看',
        width: '900px',
      })
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    appendTo: [String, Object, HTMLElement],
    imgTypeList: Array,
    pdfTypeList: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'ofd']
    },
    isPrewFileToPdf: {
      type: Boolean,
      default: false
    },
    mustPreivewType: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    componentName () {
      return this.viewType === 'image' ? 'FileImage' : 'FileItem'
    }
  },
  methods: {
    // 删除
    remove(model) {
      console.log('删除文件!', model)
      this.$emit('remove', model)
    },
    // 下载
    async download(model) {
      const fn = this.beforeDownload
      if (fn && typeof fn === 'function') {
        const beforeDownload = fn(model)
        let flag = false
        if (beforeDownload && beforeDownload.then) {
          flag = await beforeDownload
        } else {
          flag = beforeDownload
        }
        if (flag === true) {
          return false
        }
      }
      window.erpOpen(model.url)
      this.$emit('download', model)
    },
    // 预览
    async preview (model) {
      const fn = this.beforePreview
      if (fn && typeof fn === 'function') {
        const beforePreview = fn(model)
        let flag = false
        if (beforePreview && beforePreview.then) {
          flag = await beforePreview
        } else {
          flag = beforePreview
        }
        if (flag === true) {
          return false
        }
      }
      openPreview({
        ...model,
        imageProps: this.imageProps,
        dialogOption: Object.assign({}, this.$props.dialogOption),
        showDownload: this.showDownload,
        ...this.$listeners,
        appendTo: this.appendTo,
        imgTypeList: this.imgTypeList,
        pdfTypeList: this.$props.pdfTypeList,
        isPrewFileToPdf: this.$props.isPrewFileToPdf,
        mustPreivewType: this.$props.mustPreivewType,
      })
      this.$emit('preview', model)
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/public/components/kye-preview/component/index.vue